import styled from 'styled-components';

import Flex from 'components/Flex';
import { BREAKPOINTS } from 'config/constants';

/**
 * [InputWrapper] - A styled wrapper for the inputs for aligning inputs side by side on large screens and
 * stacked on mobile
 */

const InputWrapper = styled(Flex)`
  flex-direction: column;
  > div {
    flex: 1;
  }

  @media screen and (min-width: ${BREAKPOINTS.SM}px) {
    flex-direction: row;

    > div {
      margin-left: 0.5rem;
      margin-right: 0.5rem;

      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }

  p {
    font-size: 1.2rem;
  }
`;

export default InputWrapper;
